export default __webpack_public_path__ + "static/media/stats-chart.6662410f.svg";